import React from 'react';
import {NavLink, Link} from 'react-router-dom';
// OIID
// UID: Schema.Types.ObjectId, 
// scheduledAt: {type: Date}, //WHEN THE ALIGNER SHOULD BE MADE
// shippedAt: {type: Date},
// createdAt: {type: Date}, //THIS IS WHEN THE PHYSICAL ALIGNER WAS CREATED NOT WHEN THE DB OBJECT WAS LIKE IN META
// createdBy: Schema.Types.ObjectId,
// status: {type: String, default: "PENDING"}, //PENDING, ACTIVE, INACTIVE, PAUSED, 
// step: {type: String, default: "MAKE"}, 
// aligners {
//   TPID: Schema.Types.ObjectId, 
//   AGID: Schema.Types.ObjectId, 
//   UID: Schema.Types.ObjectId, 
//   files: [
//     {
//       createAt: {type: Date, default: Date.now()},
//       url: {type: String, default: ""},
//       name: {type: String, default: ""},
//       type: {type: String, default: ""},
//       id: {type: String, default: mongoose.Types.ObjectId()}
//     }
//   ],
//   status: {type: String, default: "PENDING"}, //PENDING, ACTIVE, INACTIVE, PAUSED, 
//   meta: {
//     updateAt: {type: Date, default: Date.now()},
//     createAt: {type: Date, default: Date.now()}
//   }
// }
const PREVIEW_FORM = [
  {
    "TYPE": "CUSTOM_CODE",
    "CODE": (obj)=>{
      if(!obj.aligners) return null;
      return(<AlignerGroups group={obj} />)
    }
  }
]




class AlignerGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: undefined
    };    
  }
  componentDidMount(){
  }
  render(){
    var {isActive} = this.state;
    var {group} = this.props;
    return (
      <div className="alignerGroups single">
        <AlignerGroup 
          key={0} 
          index={0}
          group={group} 
          isThisActive={true}
          toggleActive={()=>{
          }}
        />
      </div>
    );
  }
}






class AlignerGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateDiff:  "NOT SCHEDULED YET",
      scheduledAt: "NOT SCHEDULED YET"
    };    
  }
  componentDidMount(){
    this.setState({
      scheduledAt: window.GlobalUtil.dateBasic(Number(this.props.group.scheduledAt)),
      dateDiff: (this.props.group.scheduledAt ? new Date(Number(this.props.group.scheduledAt)).formatDiffFull("YNWD") :  "NOT SCHEDULED YET")
    })
  }
  render(){
    var {dateDiff, scheduledAt} = this.state;
    var {group, isThisActive, index} = this.props;
    var shippedAt = (
      group.OIID 
      ? <NavLink 
          className="" 
          to={`/admin/shipping/sendAligners/${(group.OIID ? group.OIID : '')}`} 
          onClick={()=>{
            window.GlobalUtil.DialogStack.closeAll()
          }}>
          NOT SHIPPED YET
        </NavLink> 
      : "NOT SHIPPED YET"
    );
    if(group.shippedAt) shippedAt = window.GlobalUtil.dateBasic(Number(group.shippedAt));
          
    return(
      <div className="group">
        <div className="title" onClick={this.props.toggleActive}>
          <div className="textZone">
            <div className="checkWrapper">
              <div className="check">
                {
                  group.step === "FINISHED"
                  ? <i className={`checkbox active fas fa-check-square`}></i>
                  : <i className={`checkbox far fa-square`}></i>
                }
                <div className="checkText">Shipped</div>
              </div>
            </div>
            <div className="text">
              Aligner Group
            </div>
          </div>
          <div className="fa">
            {
              isThisActive
              ? <i className="fas fa-plus animated fadeIn" />
              : <i className="fas fa-minus animated fadeIn" />
            }
          </div>
        </div>
        <div className={`accordionZone ${isThisActive ? "active" : ""}`}>
          <div className={`accordionZoneInner`}>
            <div className="cont">
              <div className="info infoTop">
                <div className="text">
                  <div className="desc">Scheduled At: </div>
                  <div className="val">{scheduledAt} {dateDiff ? `(${dateDiff})` : ''}</div>
                </div>
                <div className="text">
                  <div className="desc">Shipped At: </div>
                  <div className="val">{shippedAt}</div>
                </div>
              </div>
            </div>
            <div className="aligners">
              {
                group.aligners.map((aligner, index)=>{
                  return(
                    <div className="aligner" key={index}>
                      <div className="cont">
                        <div className="checkWrapper">
                          <div className="check">
                            {
                              (aligner.step === "FINISHED") 
                              ? <i className={`checkbox active fas fa-check-square`}></i>
                              : <i className={`checkbox far fa-square`}></i>
                            }
                            <div className="checkText">Created</div>
                          </div>
                        </div>
                        <div className="info">
                          <div className="text">
                            <div className="desc">Number: </div>
                            <div className="val">{aligner.files[0].customName}</div>
                          </div>
                          <div className="text">
                            <div className="desc">Name: </div>
                            <div className="val">{aligner.files[0].name}</div>
                          </div>
                          <div className="text">
                            <div className="desc">ID: </div>
                            <div className="val"><a href="#" onClick={(e)=>{
                              e.preventDefault()
                              window.GlobalUtil.triggerEvent("TemplateDBEvent", {
                                "BUTTON_TITLE": "Aligner",
                                "TITLE": "Aligner", //TITLE OF SLIDE OUT
                                "APINAME": "ALIGNERS",
                                "TYPE": "PREVIEW",
                                "FIELD": "aligner",
                                "ID": aligner._id
                              });
                            }}>{aligner._id}</a></div>
                          </div>
                          <div className="text">
                            <div className="desc">URL: </div>
                            <div className="val"><a href={aligner.files[0].url} download target="_blank">{aligner.files[0].url}</a></div>
                          </div>
                          <div className="text">
                            <div className="desc">Type: </div>
                            <div className="val">{aligner.files[0].type}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default PREVIEW_FORM;